import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "media-queries"
    }}>{`Media Queries`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "height.md"
        }}>{`height`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "prefers-color-scheme.md"
        }}>{`prefers-color-scheme`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "width.md"
        }}>{`width`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      